import ComponentManager from '@/Management/ComponentManager';
import Control from '@/Controls/Control';
import ToolBarType from '@/Controls/ToolBar';
import ExtIEGAssociationGridViewModel from '@/Components/ExtendedInlineEditingGrid/Associations/ExtIEGAssociationGridViewModel';
import LabelType from '@/Controls/Label';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';

export default class ExtIEGAssociationGrid extends Control {

    private ToolBar = ComponentManager.getControl<typeof ToolBarType>('ToolBar');
    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jqueryControl: JQuery;

    public constructor(private viewModel: ExtIEGAssociationGridViewModel, private element?: JQuery) {
        super(viewModel, element);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jqueryControl != null) {
            return this.jqueryControl;
        }

        this.jqueryControl = this.element || $('<div>');
        let $toolbar = $('<div class="toolbar">');
        $toolbar.appendTo(this.jqueryControl);
        let $label = $('<span>');
        $label.appendTo(this.jqueryControl);

        if (this.viewModel.toolBar != null) {
            const toolBar = new this.ToolBar(this.viewModel.toolBar, $toolbar);
            toolBar.getTuple();
        }

        if (this.viewModel.label != null) {
            const label = new this.Label(this.viewModel.label, $label);
            label.getTuple();
        }

        this.applyBindings(this.jqueryControl, {
            controlName: 'extiegassociationgrid',
            loader: this.viewModel.isBusy
        });

        this.applyBindings($label, {
            tooltip: new LabelViewModelBuilder().withCaption(this.definePureComputed({
                read: () => {
                    return this.viewModel.connectedObjectIdents().join('\n');
                }
            })).build()
        });

        return this.jqueryControl;
    }
}

ComponentManager.setControl('ExtIEGAssociationGrid', ExtIEGAssociationGrid, 'RADPresentation.HTMLClient.DefaultViewExtensions');